<template>
<v-container grid-list-sm fluid class="ma-0 pa-0">
<v-layout row wrap>
  <v-flex xs12 class="mb-2"><h1>Returns</h1></v-flex>

  <v-flex xs12>
      <v-text-field
      label="Scan or Enter Tracking Number"
      v-model="tracking_number"
      box
      hide-details
      ></v-text-field>
  </v-flex>
  <v-flex xs12>
    <v-btn large @click="onScan" :loading="ui.loading" block class="return-btn">Retrieve Draft</v-btn>
  </v-flex>
  <v-flex xs12 v-if="ui.notFound" class="text-xs-center">
    <v-alert error :value="true" class="elevation-4" style="font-weight:bold;">
      This tracking number could not be located.
    </v-alert>
  </v-flex>

  <v-flex xs12 v-if="draft">
    <v-toolbar tabs>
      <v-toolbar-title>{{tracking_number}}</v-toolbar-title>
      <v-tabs slot="extension" v-model="ui.tab" centered grow color="transparent">
        <v-tabs-slider></v-tabs-slider>
        <v-tab>Draft</v-tab>
        <v-tab>History</v-tab>
        <v-tab>Subscription</v-tab>
      </v-tabs>
    </v-toolbar>

    <v-tabs-items v-model="ui.tab" class="elevation-2">
      <v-tab-item>
        <v-card flat>
          <v-card-text>
            <v-flex xs12>
              <h3>Draft Items</h3>
              <v-data-table
                  :headers="line_item_headers"
                  :items.sync="draft.line_items"
                  :hide-actions="draft.line_items.length <= 10"
                  :row-per-page-items="ui.rowPerPageItems"
                  no-data-text="No items will be billed to customer."
                  class="elevation-1 mt-2 mb-2"
              >
                  <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
                  <template slot="items" slot-scope="props">
                    <tr @click="removeItem(props.item)" style="cursor:pointer;height:90px;" :class="{'packed': props.item.quantity === 0}">
                      <td>
                          <v-img v-if="props.item.image" :src="props.item.image" width="80"/>
                          <div v-else class="primary" style="width:80px;height:80px;"></div>
                      </td>
                      <td>{{ props.item.title }}</td>
                      <td>{{ props.item.sku }}</td>
                      <td class="text-xs-center">{{ props.item.quantity }}</td>
                      <td class="text-xs-right"><v-btn>remove</v-btn></td>
                    </tr>
                  </template>
              </v-data-table>
            </v-flex>

            <v-flex xs12 class="mt-3">
              <h3>Removed Items</h3>
              <v-data-table
                  hide-headers
                  no-data-text="No draft items to remove yet."
                  :items.sync="removedItems"
                  hide-actions
                  class="elevation-1 mt-2"
              >
                  <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
                  <template slot="items" slot-scope="props">
                    <tr @click="addItem(props.item)" style="cursor:pointer;height:90px;">
                      <td>
                          <v-img v-if="props.item.image" :src="props.item.image" width="80"/>
                          <div v-else class="primary" style="width:80px;height:80px;"></div>
                      </td>
                      <td>{{ props.item.title }}</td>
                      <td>{{ props.item.sku }}</td>
                      <td class="text-xs-center">{{ props.item.quantity }}</td>
                      <td class="text-xs-right"><v-btn>add</v-btn></td>
                    </tr>
                  </template>
              </v-data-table>

              <!--<v-btn block @click="testing">testing</v-btn>-->
            </v-flex>

            <v-layout row wrap class="pb-0 mb-0 mt-2">
            <v-flex xs12 class="pb-0"><v-btn @click="updateDraft" :loading="ui.loading" large style="border-radius:0px;" block class="return-btn pb-0">update draft</v-btn></v-flex>
            </v-layout>

          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat>
          <v-card-text>

            <v-timeline
              align-top
              dense
            >
              <v-timeline-item
                v-for="(detail, i) in tracking_label.tracking_details"
                :key="i"
                small
              >
                <v-layout pt-3>
                  <v-flex xs3>
                    <strong>{{detail.datetime | toTimestamp}}</strong>
                  </v-flex>
                  <v-flex>
                    <strong>{{detail.message}}</strong>
                    <div class="caption">{{detail.tracking_location.city}} {{detail.tracking_location.state}} {{detail.tracking_location.zip}}
                    </div>
                  </v-flex>
                </v-layout>
              </v-timeline-item>
            </v-timeline>

          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat>
          <v-card-text>
            <v-container grid-list-sm class="ma-0 pa-0" v-if="subscription">
              <v-layout row wrap>
                <v-flex xs12 sm8>
                  <v-layout row wrap>
                    <v-flex xs12 sm6><v-text-field label="First Name" :value="subscription.customer.first_name" box readonly hide-details></v-text-field></v-flex>
                    <v-flex xs12 sm6><v-text-field label="Last Name" :value="subscription.customer.last_name" box readonly hide-details></v-text-field></v-flex>
                    <v-flex xs12 sm12><v-text-field label="Email" :value="subscription.customer.email" box readonly hide-details></v-text-field></v-flex>
                    <v-flex xs12 sm12><v-text-field label="Address" :value="subscription.customer.default_address.address1" box readonly hide-details></v-text-field></v-flex>
                    <v-flex xs12 sm12><v-text-field label="Address 2" :value="subscription.customer.default_address.address2" box readonly hide-details></v-text-field></v-flex>
                    <v-flex xs12 sm4><v-text-field label="City" :value="subscription.customer.default_address.city" box readonly hide-details></v-text-field></v-flex>
                    <v-flex xs12 sm4><v-text-field label="State" :value="subscription.customer.default_address.province" box readonly hide-details></v-text-field></v-flex>
                    <v-flex xs12 sm4><v-text-field label="Zip" :value="subscription.customer.default_address.zip" box readonly hide-details></v-text-field></v-flex>
                    <v-flex xs12 sm12><v-text-field label="Country" :value="subscription.customer.default_address.country" box readonly hide-details></v-text-field></v-flex>
                    <v-flex xs12 sm12 v-if="subscription.customer.default_address.phone"><v-text-field label="Phone" :value="subscription.customer.default_address.phone" box readonly hide-details></v-text-field></v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-list class="pt-0 subscriber-details" style="background:transparent!important;">
                    <v-list-tile>
                      <v-list-tile-content>
                        <v-list-tile-title>Account ID</v-list-tile-title>
                        <v-list-tile-sub-title>{{subscription.customer.id}}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile>
                      <v-list-tile-content>
                        <v-list-tile-title>Subscription ID</v-list-tile-title>
                        <v-list-tile-sub-title>{{subscription.id}}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile v-if="subscription.subscription_product_title">
                      <v-list-tile-content>
                        <v-list-tile-title>Subscription Product</v-list-tile-title>
                        <v-list-tile-sub-title>{{subscription_product_title}}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile v-if="subscription.subscription_variant_sku">
                      <v-list-tile-content>
                        <v-list-tile-title>Subscription SKU</v-list-tile-title>
                        <v-list-tile-sub-title>{{subscription_variant_sku}}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile>
                      <v-list-tile-content>
                        <v-list-tile-title>Subscription Start</v-list-tile-title>
                        <v-list-tile-sub-title>{{subscription.subscription_start | toTimestamp}}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile v-if="subscription.subscription_end">
                      <v-list-tile-content>
                        <v-list-tile-title>Subscription End</v-list-tile-title>
                        <v-list-tile-sub-title>{{subscription.subscription_end | toTimestamp}}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile>
                      <v-list-tile-content>
                        <v-list-tile-title>Last Box Date</v-list-tile-title>
                        <v-list-tile-sub-title>{{subscription.last_box_date | toTimestamp}}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile>
                      <v-list-tile-content>
                        <v-list-tile-title>Has Draft</v-list-tile-title>
                        <v-list-tile-sub-title>{{subscription.has_draft ? 'Yes' : 'No'}}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile>
                      <v-list-tile-content>
                        <v-list-tile-title>Draft ID</v-list-tile-title>
                        <v-list-tile-sub-title>{{draft.id}}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-flex>

</v-layout>
</v-container>
</template>
<script>
import { db, functions } from '@/services/firebase.js'
import moment from 'moment'
import { isUndefined } from 'lodash'

export default {
    data () {
        return {
            ui: {
                loading: false,
                notFound: false,
                tab: null,
                rowsPerPageItems: [10, 25, { "text": "$vuetify.dataIterator.rowsPerPageAll", "value": -1 }]
            },
            products: [],
            shipment_settings: null,
            tracking_number: null,
            tracking_label: null,
            draft: null,
            subscription: null,
            removedItems: [],
            line_item_headers: [
              { text: '', value: 'image', sortable: false },
              { text: 'Item', align: 'left', value: 'title', sortable: false },
              { text: 'SKU', value: 'sku', sortable: false },
              { text: 'Qty', value: 'quantity', width: 20, sortable: false },
              { text: '', align: 'right', value: 'pack', sortable: false }
            ]
        }
    },
    filters: {
      toDate: function(str){
        return moment(str).format('MM/DD/YY')
      },
      toTimestamp: function(str){
        return moment(str).format('MM/DD/YY hh:mm:ss A')
      },
      toOunces: function(grams) {
        return Math.ceil(grams * 0.0352739619)
      }
    },
    computed: {
        isAdmin () {
            return this.$store.getters.isAdmin !== null && this.$store.getters.isAdmin !== undefined
        },
        isManager () {
            return this.$store.getters.isManager !== null && this.$store.getters.isManager !== undefined
        },
        isDark: function () {
            return this.$vuetify.dark
        },
        calculatedDetailsDraftTotal: function () {
          var self = this
          if(self.draft){
            var total = 0
            self.draft.line_items.forEach((item) => {
              total = total + parseFloat(item.price)
            })
            return '$' + total.toFixed(2)
          } else {
            return '$0.00'
          }
        }
    },
    methods: {
      onScan: function () {
        var self = this

        if (self.tracking_number) {
          
          self.tracking_label = null
          self.draft = null
          self.removedItems = []
          self.subscription = null
          self.ui.notFound = false
          self.ui.loading = true

          db.collection("tracking").doc(self.tracking_number).get()
          .then((tracking_doc) => {
            let tracking_label = tracking_doc.data()

            if (!isUndefined(tracking_label)) {

              self.tracking_label = tracking_label
              
              self.getDraft(tracking_label.draft_id)
              self.getSubscription(tracking_label.subscription_id)

              self.ui.loading = false

            } else {
              self.ui.loading = false
              self.ui.notFound = true
            }

          })
          .catch((err) => {
            console.error(err)
            self.ui.loading = false
            self.ui.notFound = true
          })
        }  
      },
      getDraft: function (draft_id) {
        var self = this
        db.collection("drafts").doc(draft_id.toString()).get()
        .then((draft_doc) => {
          let draft = draft_doc.data()

          draft.line_items.forEach((item) => {

              item.image = null
              item.product = null
              item.item_inventory_id = null
              item.product_inventory_location = self.shipment_settings.inventory_location.id

              var product = self.products.find((item_product) => {
                  return item_product.id === item.product_id
              })

              if (!isUndefined(product)) {
                  item.image = product.image
                  item.product = product
                  
                  var variant = product.variants.find((v) => {
                      return v.sku === item.sku
                  })

                  item.inventory_item_id = variant.inventory_item_id
              }
          })
          //console.log(draft)
          self.draft = draft
        })
        .catch((err) => {
          console.error(err)
        })
      },
      getSubscription: function (subscription_id) {
        var self = this
        db.collection("subscriptions").doc(subscription_id.toString()).get()
        .then((subscription_doc) => {
          self.subscription = subscription_doc.data()
          //console.log(self.subscription)
        })
        .catch((err) => {
          console.error(err)
        })
      },
      removeItem: function (item) {
        var self = this
        /*
        self.removedItems.push(item)
        self.draft.line_items = self.draft.line_items.filter((line_item) => {
          return !isEqual(item, line_item)
        })
        */
        var removed_item_index = self.removedItems.findIndex((i) => {
            return i.sku === item.sku
        })
        var draft_item_index = self.draft.line_items.findIndex((i) => {
          return i.sku === item.sku
        })
        if (item.quantity > 0) {

            item.quantity = item.quantity - 1

            self.draft.line_items[draft_item_index].quantity = item.quantity

            item = JSON.parse(JSON.stringify(item))
            
            if (self.removedItems.length === 0) {
                item.quantity = 1
                self.removedItems.push(item)
            } else {

                if (removed_item_index !== -1) {
                    self.removedItems[removed_item_index].quantity++
                } else {
                    item.quantity = 1
                    /*
                    let product = self.products.find((product) => {
                      return product.product_id = item.product_id
                    })
                    let variant = self.product.variants.find((variant) => {
                      return variant.variant_id = item.variant_id
                    })
                    item.inventory_item_id = variant.inventory_item_id
                    */
                    self.removedItems.push(item)
                }
            }
        }    
      },
      addItem: function (item) {
        var self = this
        /*
        self.draft.line_items.push(item)
        self.removedItems = self.removedItems.filter((line_item) => {
          return !isEqual(item, line_item)
        })
        */
        var removed_item_index = self.removedItems.findIndex((i) => {
            return i.sku === item.sku
        })
        var draft_item_index = self.draft.line_items.findIndex((i) => {
            return i.sku === item.sku
        })

        if (item.quantity === 1) {
            self.removedItems.splice(removed_item_index, 1)
         } else {
            self.removedItems[removed_item_index].quantity--
        }

        self.draft.line_items[draft_item_index].quantity++
      },
      updateDraft: function () {
        var self = this
        self.ui.loading = true

        var items = []
        
        self.draft.line_items.forEach((item) => {
          if (item.quantity !== 0) {
            items.push(item)
          }
        })

        self.draft.line_items = items

        console.log('Updating Draft:', self.draft.line_items)
        
        var processDraftOrderReturns = functions.httpsCallable('processDraftOrderReturns')
        processDraftOrderReturns({draft_id: self.draft.id, update: {line_items: self.draft.line_items}, subscription_id: self.draft.subscription_id, returned_items: self.removedItems})
        .then((result) => {
          console.log(result)
          self.draft = null
          self.tracking_number = null
          if (result) {
            self.ui.loading = false
            // self.onScan()
            self.draft = null
            self.tracking_number = null

          } else {
            self.ui.loading = false
            // self.$root.$emit('event', {type: 'error', event: 'Returns were not updated for: ' + self.draft.id})
            self.draft = null
            self.tracking_number = null
          }
        })
        .catch((err) => {
            console.error(err)
            self.$root.$emit('event', {type: 'error', event: 'Returns were not updated for: ' + self.draft.id})
            self.ui.loading = false
        })
      },
      billCustomer: function () {
        var self = this
        self.ui.loading = true

        var billCustomer = functions.httpsCallable('chargeCustomerForDraft')
        billCustomer({draft_id: self.draft.id.toString(), vault_id: self.subscription.vault_id, payment_profile_id: self.subscription.payment_profile_id})
        .then((result) => {
          if (result.sucesss) {

            self.ui.loading = false
            self.$root.$emit('event', {type: 'info', event: 'Subscriber was successfully billed for: ' + self.draft.id})

          } else {
            self.ui.loading = false
            self.$root.$emit('event', {type: 'error', event: 'Subscriber was not successfully billed for: ' + self.draft.id})
          }
        })
        .catch((err) => {
            console.error(err)
            self.$root.$emit('event', {type: 'error', event: 'Subscriber was not successfully billed for: ' + self.draft.id})
            self.ui.loading = false
        })
      },
      reset: function () {
        var self = this
        self.tracking_number = null
        self.tracking_label = null
        self.draft = null
        self.subscription = null
      },
      testing: function () {
        var self = this

        const isLastItem = function (line_items, returned_items) {
            let returnedItemsEqualsLineItemsLeft = returned_items.length === line_items.length
            if (returnedItemsEqualsLineItemsLeft) {
                var isNotZeroQuantity = 0
                for (let item of line_items) {
                   let returnedItem = returned_items.find((returned) => {
                      return returned.inventory_item_id === item.inventory_item_id
                    })
                    let currentItemQuantity = (item.quantity - returnedItem.quantity)
                    if (currentItemQuantity > 0) {
                        isNotZeroQuantity++
                    }
                }
                if (isNotZeroQuantity > 0) return false
                else return true
            } else {
                return false
            }
        }
        console.log(isLastItem(self.draft.line_items, self.removedItems), self.draft.line_items, self.removedItems)
      }
    },
    created () {
      var self = this
      db.collection('products').onSnapshot(productSnapshot => {
          var products = []
          productSnapshot.forEach(function(doc) {
              products.push(doc.data())
          })
          self.products = products
      })
      db.collection('settings').doc('shipments').onSnapshot(shipmentSettingsSnapshot => { 
          self.shipment_settings = shipmentSettingsSnapshot.data()
      })
    },
    mounted () {

    }
}
</script>
<style lang="stylus" scoped>
.theme--dark-old .return-btn
  background #0d2029!important
.theme--dark-old .v-card
  background #1d2935!important
.packed
  opacity 0.25
</style>